export let intCountry = [
  { 'cnName': '阿富汗', 'enName': 'Afghanistan', 'enAbbr': 'AF' },
  { 'cnName': '阿尔巴尼亚', 'enName': 'Albania', 'enAbbr': 'AL' },
  { 'cnName': '阿尔及利亚', 'enName': 'Algeria', 'enAbbr': 'DZ' },
  { 'cnName': '美属萨摩亚', 'enName': 'American Samoa', 'enAbbr': 'AS' },
  { 'cnName': '安道尔', 'enName': 'Andorra', 'enAbbr': 'AD' },
  { 'cnName': '安哥拉', 'enName': 'Angola', 'enAbbr': 'AO' },
  { 'cnName': '安圭拉', 'enName': 'Anguilla', 'enAbbr': 'AI' },
  { 'cnName': '安提瓜和巴布达', 'enName': 'Antigua', 'enAbbr': 'AG' },
  { 'cnName': '阿根廷', 'enName': 'Argentina', 'enAbbr': 'AR' },
  { 'cnName': '亚美尼亚', 'enName': 'Armenia', 'enAbbr': 'AM' },
  { 'cnName': '阿鲁巴', 'enName': 'Aruba', 'enAbbr': 'AW' },
  { 'cnName': '澳大利亚', 'enName': 'Australia', 'enAbbr': 'AU' },
  { 'cnName': '奥地利', 'enName': 'Austria', 'enAbbr': 'AT' },
  { 'cnName': '阿塞拜疆', 'enName': 'Azerbaijan', 'enAbbr': 'AZ' },
  { 'cnName': '巴哈马', 'enName': 'Bahamas', 'enAbbr': 'BS' },
  { 'cnName': '巴林', 'enName': 'Bahrain', 'enAbbr': 'BH' },
  { 'cnName': '孟加拉国', 'enName': 'Bangladesh', 'enAbbr': 'BD' },
  { 'cnName': '巴巴多斯', 'enName': 'Barbados', 'enAbbr': 'BB' },
  { 'cnName': '安提瓜和巴布达', 'enName': 'Barbuda', 'enAbbr': 'AG' },
  { 'cnName': '白俄罗斯', 'enName': 'Belarus', 'enAbbr': 'BY' },
  { 'cnName': '比利时', 'enName': 'Belgium', 'enAbbr': 'BE' },
  { 'cnName': '伯利兹', 'enName': 'Belize', 'enAbbr': 'BZ' },
  { 'cnName': '贝宁', 'enName': 'Benin', 'enAbbr': 'BJ' },
  { 'cnName': '百慕大', 'enName': 'Bermuda', 'enAbbr': 'BM' },
  { 'cnName': '不丹', 'enName': 'Bhutan', 'enAbbr': 'BT' },
  { 'cnName': '玻利维亚', 'enName': 'Bolivia', 'enAbbr': 'BO' },
  { 'cnName': '伯奈尔', 'enName': 'Bonaire', 'enAbbr': 'XB' },
  { 'cnName': '波黑', 'enName': 'Bosnia-Herzegovina', 'enAbbr': 'BA' },
  { 'cnName': '博茨瓦纳', 'enName': 'Botswana', 'enAbbr': 'BW' },
  { 'cnName': '巴西', 'enName': 'Brazil', 'enAbbr': 'BR' },
  { 'cnName': '英属维尔京群岛', 'enName': 'British Virgin Islands', 'enAbbr': 'VG' },
  { 'cnName': '文莱', 'enName': 'Brunei', 'enAbbr': 'BN' },
  { 'cnName': '保加利亚', 'enName': 'Bulgaria', 'enAbbr': 'BG' },
  { 'cnName': '布基纳法索', 'enName': 'Burkina Faso', 'enAbbr': 'BF' },
  { 'cnName': '布隆迪', 'enName': 'Burundi', 'enAbbr': 'BI' },
  { 'cnName': '柬埔寨', 'enName': 'Cambodia', 'enAbbr': 'KH' },
  { 'cnName': '喀麦隆', 'enName': 'Cameroon', 'enAbbr': 'CM' },
  { 'cnName': '加拿大', 'enName': 'Canada', 'enAbbr': 'CA' },
  { 'cnName': '加那利群岛', 'enName': 'Canary Islands', 'enAbbr': 'Z5' },
  { 'cnName': '佛得角', 'enName': 'Cape Verde', 'enAbbr': 'CV' },
  { 'cnName': '开曼群岛', 'enName': 'Cayman Islands', 'enAbbr': 'KY' },
  { 'cnName': '乍得', 'enName': 'Chad', 'enAbbr': 'TD' },
  { 'cnName': '海峡群岛', 'enName': 'Channel Islands', 'enAbbr': 'A1' },
  { 'cnName': '智利', 'enName': 'Chile', 'enAbbr': 'CL' },
  { 'cnName': '哥伦比亚', 'enName': 'Colombia', 'enAbbr': 'CO' },
  { 'cnName': '刚果（布）', 'enName': 'Congo', 'enAbbr': 'CG' },
  { 'cnName': '刚果（金）', 'enName': 'Congo, Dem Rep Of', 'enAbbr': 'CD' },
  { 'cnName': '库克群岛', 'enName': 'Cook Islands', 'enAbbr': 'CK' },
  { 'cnName': '哥斯达黎加', 'enName': 'Costa Rica', 'enAbbr': 'CR' },
  { 'cnName': '克罗地亚', 'enName': 'Croatia', 'enAbbr': 'HR' },
  { 'cnName': '荷属库拉索岛', 'enName': 'Curacao', 'enAbbr': 'A3' },
  { 'cnName': '塞浦路斯', 'enName': 'Cyprus', 'enAbbr': 'CY' },
  { 'cnName': '捷克', 'enName': 'Czech Republic', 'enAbbr': 'CZ' },
  { 'cnName': '丹麦', 'enName': 'Denmark', 'enAbbr': 'DK' },
  { 'cnName': '吉布提', 'enName': 'Djibouti', 'enAbbr': 'DJ' },
  { 'cnName': '多米尼克', 'enName': 'Dominica', 'enAbbr': 'DM' },
  { 'cnName': '多米尼加', 'enName': 'Dominican Republic', 'enAbbr': 'DO' },
  { 'cnName': '东帝汶', 'enName': 'East Timor', 'enAbbr': 'TP' },
  { 'cnName': '厄瓜多尔', 'enName': 'Ecuador', 'enAbbr': 'EC' },
  { 'cnName': '埃及', 'enName': 'Egypt', 'enAbbr': 'EG' },
  { 'cnName': '萨尔瓦多', 'enName': 'El Salvador', 'enAbbr': 'SV' },
  { 'cnName': '厄立特里亚', 'enName': 'Eritrea', 'enAbbr': 'ER' },
  { 'cnName': '爱沙尼亚', 'enName': 'Estonia', 'enAbbr': 'EE' },
  { 'cnName': '埃塞俄比亚', 'enName': 'Ethiopia', 'enAbbr': 'ET' },
  { 'cnName': '法罗群岛', 'enName': 'Faeroe Islands', 'enAbbr': 'FO' },
  { 'cnName': '斐济', 'enName': 'Fiji', 'enAbbr': 'FJ' },
  { 'cnName': '芬兰', 'enName': 'Finland', 'enAbbr': 'FI' },
  { 'cnName': '法国', 'enName': 'France', 'enAbbr': 'FR' },
  { 'cnName': '法属圭亚那', 'enName': 'French Guiana', 'enAbbr': 'GF' },
  { 'cnName': '法属波利尼西亚', 'enName': 'French Polynesia', 'enAbbr': 'PF' },
  { 'cnName': '加蓬', 'enName': 'Gabon', 'enAbbr': 'GA' },
  { 'cnName': '冈比亚', 'enName': 'Gambia', 'enAbbr': 'GM' },
  { 'cnName': '格鲁吉亚', 'enName': 'Georgia', 'enAbbr': 'GE' },
  { 'cnName': '德国', 'enName': 'Germany', 'enAbbr': 'DE' },
  { 'cnName': '加纳', 'enName': 'Ghana', 'enAbbr': 'GH' },
  { 'cnName': '直布罗陀', 'enName': 'Gibraltar', 'enAbbr': 'GI' },
  { 'cnName': '开曼群岛', 'enName': 'Grand Cayman', 'enAbbr': 'KY' },
  { 'cnName': '大茅岛', 'enName': 'Great Thatch Island', 'enAbbr': 'G1' },
  { 'cnName': '大多巴哥群岛', 'enName': 'Great Tobago Islands', 'enAbbr': 'G2' },
  { 'cnName': '希腊', 'enName': 'Greece', 'enAbbr': 'GR' },
  { 'cnName': '格陵兰', 'enName': 'Greenland', 'enAbbr': 'GL' },
  { 'cnName': '格林纳达', 'enName': 'Grenada', 'enAbbr': 'GD' },
  { 'cnName': '瓜德罗普', 'enName': 'Guadeloupe', 'enAbbr': 'GP' },
  { 'cnName': '关岛', 'enName': 'Guam', 'enAbbr': 'GU' },
  { 'cnName': '危地马拉', 'enName': 'Guatemala', 'enAbbr': 'GT' },
  { 'cnName': '几内亚', 'enName': 'Guinea', 'enAbbr': 'GN' },
  { 'cnName': '圭亚那', 'enName': 'Guyana', 'enAbbr': 'GY' },
  { 'cnName': '海地', 'enName': 'Haiti', 'enAbbr': 'HT' },
  { 'cnName': '洪都拉斯', 'enName': 'Honduras', 'enAbbr': 'HN' },
  { 'cnName': '匈牙利', 'enName': 'Hungary', 'enAbbr': 'HU' },
  { 'cnName': '冰岛', 'enName': 'Iceland', 'enAbbr': 'IS' },
  { 'cnName': '印度', 'enName': 'India', 'enAbbr': 'IN' },
  { 'cnName': '印度尼西亚', 'enName': 'Indonesia', 'enAbbr': 'ID' },
  { 'cnName': '伊朗', 'enName': 'Iran', 'enAbbr': 'IR' },
  { 'cnName': '伊拉克', 'enName': 'Iraq', 'enAbbr': 'IQ' },
  { 'cnName': '爱尔兰', 'enName': 'Ireland', 'enAbbr': 'IE' },
  { 'cnName': '以色列', 'enName': 'Israel', 'enAbbr': 'IL' },
  { 'cnName': '意大利', 'enName': 'Italy', 'enAbbr': 'IT' },
  { 'cnName': '科特迪瓦', 'enName': 'Ivory Coast', 'enAbbr': 'CI' },
  { 'cnName': '牙买加', 'enName': 'Jamaica', 'enAbbr': 'JM' },
  { 'cnName': '日本', 'enName': 'Japan', 'enAbbr': 'JP' },
  { 'cnName': '约旦', 'enName': 'Jordan', 'enAbbr': 'JO' },
  { 'cnName': '英属维尔京群岛', 'enName': 'Jost Van Dyke Islands', 'enAbbr': 'VG' },
  { 'cnName': '哈萨克斯坦', 'enName': 'Kazakhstan', 'enAbbr': 'KZ' },
  { 'cnName': '肯尼亚', 'enName': 'Kenya', 'enAbbr': 'KE' },
  { 'cnName': '科威特', 'enName': 'Kuwait', 'enAbbr': 'KW' },
  { 'cnName': '吉尔吉斯斯坦', 'enName': 'Kyrgyzstan', 'enAbbr': 'KG' },
  { 'cnName': '老挝', 'enName': 'Laos', 'enAbbr': 'LA' },
  { 'cnName': '拉脱维亚', 'enName': 'Latvia', 'enAbbr': 'LV' },
  { 'cnName': '黎巴嫩', 'enName': 'Lebanon', 'enAbbr': 'LB' },
  { 'cnName': '莱索托', 'enName': 'Lesotho', 'enAbbr': 'LS' },
  { 'cnName': '利比里亚', 'enName': 'Liberia', 'enAbbr': 'LR' },
  { 'cnName': '利比亚', 'enName': 'Libya', 'enAbbr': 'LY' },
  { 'cnName': '列支敦士登', 'enName': 'Liechtenstein', 'enAbbr': 'LI' },
  { 'cnName': '立陶宛', 'enName': 'Lithuania', 'enAbbr': 'LT' },
  { 'cnName': '卢森堡', 'enName': 'Luxembourg', 'enAbbr': 'LU' },
  { 'cnName': '前南马其顿', 'enName': 'Macedonia', 'enAbbr': 'MK' },
  { 'cnName': '马达加斯加', 'enName': 'Madagascar', 'enAbbr': 'MG' },
  { 'cnName': '马拉维', 'enName': 'Malawi', 'enAbbr': 'MW' },
  { 'cnName': '马来西亚', 'enName': 'Malaysia', 'enAbbr': 'MY' },
  { 'cnName': '马尔代夫', 'enName': 'Maldives', 'enAbbr': 'MV' },
  { 'cnName': '马里', 'enName': 'Mali', 'enAbbr': 'ML' },
  { 'cnName': '马耳他', 'enName': 'Malta', 'enAbbr': 'MT' },
  { 'cnName': '马绍尔群岛', 'enName': 'Marshall Islands', 'enAbbr': 'MH' },
  { 'cnName': '马提尼克', 'enName': 'Martinique', 'enAbbr': 'MQ' },
  { 'cnName': '毛里塔尼亚', 'enName': 'Mauritania', 'enAbbr': 'MR' },
  { 'cnName': '毛里求斯', 'enName': 'Mauritius', 'enAbbr': 'MU' },
  { 'cnName': '墨西哥', 'enName': 'Mexico', 'enAbbr': 'MX' },
  { 'cnName': '密克罗尼西亚联邦', 'enName': 'Micronesia', 'enAbbr': 'FM' },
  { 'cnName': '摩尔多瓦', 'enName': 'Moldova', 'enAbbr': 'MD' },
  { 'cnName': '摩纳哥', 'enName': 'Monaco', 'enAbbr': 'MC' },
  { 'cnName': '蒙古', 'enName': 'Mongolia', 'enAbbr': 'MN' },
  { 'cnName': '黑山共和国', 'enName': 'Montenegro', 'enAbbr': 'ME' },
  { 'cnName': '蒙特塞拉特', 'enName': 'Montserrat', 'enAbbr': 'MS' },
  { 'cnName': '摩洛哥', 'enName': 'Morocco', 'enAbbr': 'MA' },
  { 'cnName': '莫桑比克', 'enName': 'Mozambique', 'enAbbr': 'MZ' },
  { 'cnName': '纳米比亚', 'enName': 'Namibia', 'enAbbr': 'NA' },
  { 'cnName': '尼泊尔', 'enName': 'Nepal', 'enAbbr': 'NP' },
  { 'cnName': '荷兰', 'enName': 'Netherlands', 'enAbbr': 'NL' },
  { 'cnName': '圣基茨和尼维斯', 'enName': 'Nevis', 'enAbbr': 'KN' },
  { 'cnName': '新喀里多尼亚', 'enName': 'New Caledonia', 'enAbbr': 'NC' },
  { 'cnName': '新西兰', 'enName': 'New Zealand', 'enAbbr': 'NZ' },
  { 'cnName': '尼加拉瓜', 'enName': 'Nicaragua', 'enAbbr': 'NI' },
  { 'cnName': '尼日尔', 'enName': 'Niger', 'enAbbr': 'NE' },
  { 'cnName': '尼日利亚', 'enName': 'Nigeria', 'enAbbr': 'NG' },
  { 'cnName': '诺福克岛', 'enName': 'Norfolk Island', 'enAbbr': 'NF' },
  { 'cnName': '诺曼岛', 'enName': 'Norman Island', 'enAbbr': 'G4' },
  { 'cnName': '北马里亚纳', 'enName': 'Northern Mariana Islands', 'enAbbr': 'MP' },
  { 'cnName': '挪威', 'enName': 'Norway', 'enAbbr': 'NO' },
  { 'cnName': '阿曼', 'enName': 'Oman', 'enAbbr': 'OM' },
  { 'cnName': '巴基斯坦', 'enName': 'Pakistan', 'enAbbr': 'PK' },
  { 'cnName': '帕劳', 'enName': 'Palau', 'enAbbr': 'PW' },
  { 'cnName': '巴勒斯坦', 'enName': 'Palestine Autonomous', 'enAbbr': 'PS' },
  { 'cnName': '巴拿马', 'enName': 'Panama', 'enAbbr': 'PA' },
  { 'cnName': '巴布亚新几内亚', 'enName': 'Papua New Guinea', 'enAbbr': 'PG' },
  { 'cnName': '巴拉圭', 'enName': 'Paraguay', 'enAbbr': 'PY' },
  { 'cnName': '秘鲁', 'enName': 'Peru', 'enAbbr': 'PE' },
  { 'cnName': '菲律宾', 'enName': 'Philippines', 'enAbbr': 'PH' },
  { 'cnName': '波兰', 'enName': 'Poland', 'enAbbr': 'PL' },
  { 'cnName': '葡萄牙', 'enName': 'Portugal', 'enAbbr': 'PT' },
  { 'cnName': '波多黎各', 'enName': 'Puerto Rico', 'enAbbr': 'PR' },
  { 'cnName': '卡塔尔', 'enName': 'Qatar', 'enAbbr': 'QA' },
  { 'cnName': '留尼汪', 'enName': 'Reunion', 'enAbbr': 'RE' },
  { 'cnName': '罗马尼亚', 'enName': 'Romania', 'enAbbr': 'RO' },
  { 'cnName': '罗塔岛', 'enName': 'Rota', 'enAbbr': 'M3' },
  { 'cnName': '俄罗斯联邦', 'enName': 'Russia', 'enAbbr': 'RU' },
  { 'cnName': '卢旺达', 'enName': 'Rwanda', 'enAbbr': 'RW' },
  { 'cnName': '萨巴岛', 'enName': 'Saba', 'enAbbr': 'B1' },
  { 'cnName': '塞班岛', 'enName': 'Saipan', 'enAbbr': 'M4' },
  { 'cnName': '萨摩亚', 'enName': 'Samoa', 'enAbbr': 'WS' },
  { 'cnName': '圣马力诺', 'enName': 'San Marino', 'enAbbr': 'SM' },
  { 'cnName': '沙特阿拉伯', 'enName': 'Saudi Arabia', 'enAbbr': 'SA' },
  { 'cnName': '塞内加尔', 'enName': 'Senegal', 'enAbbr': 'SN' },
  { 'cnName': '塞尔维亚', 'enName': 'Serbia', 'enAbbr': 'RS' },
  { 'cnName': '塞舌尔', 'enName': 'Seychelles', 'enAbbr': 'SC' },
  { 'cnName': '新加坡', 'enName': 'Singapore', 'enAbbr': 'SG' },
  { 'cnName': '斯洛伐克', 'enName': 'Slovak Republic', 'enAbbr': 'SK' },
  { 'cnName': '斯洛文尼亚', 'enName': 'Slovenia', 'enAbbr': 'SI' },
  { 'cnName': '南非', 'enName': 'South Africa', 'enAbbr': 'ZA' },
  { 'cnName': '韩国', 'enName': 'South Korea', 'enAbbr': 'KR' },
  { 'cnName': '西班牙', 'enName': 'Spain', 'enAbbr': 'ES' },
  { 'cnName': '斯里兰卡', 'enName': 'Sri Lanka', 'enAbbr': 'LK' },
  { 'cnName': '圣巴泰勒米', 'enName': 'St. Barthelemy', 'enAbbr': 'A4' },
  { 'cnName': '圣克里斯托弗', 'enName': 'St. Christopher', 'enAbbr': 'K1' },
  { 'cnName': '圣克罗伊岛', 'enName': 'St. Croix Island', 'enAbbr': 'V2' },
  { 'cnName': '圣尤斯特歇斯', 'enName': 'St. Eustatius', 'enAbbr': 'A2' },
  { 'cnName': '圣约翰岛', 'enName': 'St. John', 'enAbbr': 'V3' },
  { 'cnName': '圣卢西亚', 'enName': 'St. Lucia', 'enAbbr': 'LC' },
  { 'cnName': '圣马丁', 'enName': 'St. Maarten', 'enAbbr': 'A5' },
  { 'cnName': '圣马丁', 'enName': 'St. Martin', 'enAbbr': 'A5' },
  { 'cnName': '圣托马斯', 'enName': 'St. Thomas', 'enAbbr': 'V4' },
  { 'cnName': '圣文森特和格林纳丁斯', 'enName': 'St. Vincent', 'enAbbr': 'VC' },
  { 'cnName': '苏里南', 'enName': 'Suriname', 'enAbbr': 'SR' },
  { 'cnName': '斯威士兰', 'enName': 'Swaziland', 'enAbbr': 'SZ' },
  { 'cnName': '瑞典', 'enName': 'Sweden', 'enAbbr': 'SE' },
  { 'cnName': '瑞士', 'enName': 'Switzerland', 'enAbbr': 'CH' },
  { 'cnName': '叙利亚', 'enName': 'Syria', 'enAbbr': 'SY' },
  { 'cnName': '大溪地', 'enName': 'Tahiti', 'enAbbr': 'P2' },
  { 'cnName': '坦桑尼亚', 'enName': 'Tanzania', 'enAbbr': 'TZ' },
  { 'cnName': '泰国', 'enName': 'Thailand', 'enAbbr': 'TH' },
  { 'cnName': '天宁岛', 'enName': 'Tinian', 'enAbbr': 'M5' },
  { 'cnName': '多哥', 'enName': 'Togo', 'enAbbr': 'TG' },
  { 'cnName': '汤加', 'enName': 'Tonga', 'enAbbr': 'TO' },
  { 'cnName': '托托拉岛', 'enName': 'Tortola Island', 'enAbbr': 'G5' },
  { 'cnName': '特立尼达和多巴哥', 'enName': 'Trinidad & Tobago', 'enAbbr': 'TT' },
  { 'cnName': '突尼斯', 'enName': 'Tunisia', 'enAbbr': 'TN' },
  { 'cnName': '土耳其', 'enName': 'Turkey', 'enAbbr': 'TR' },
  { 'cnName': '特克斯和凯科斯群岛', 'enName': 'Turks & Caicos Islands', 'enAbbr': 'TC' },
  { 'cnName': '美属维尔京群岛', 'enName': 'U.S. Virgin Islands', 'enAbbr': 'VI' },
  { 'cnName': '乌干达', 'enName': 'Uganda', 'enAbbr': 'UG' },
  { 'cnName': '乌克兰', 'enName': 'Ukraine', 'enAbbr': 'UA' },
  { 'cnName': '尤宁群岛', 'enName': 'Union Island', 'enAbbr': 'V1' },
  { 'cnName': '阿联酋', 'enName': 'United Arab Emirates', 'enAbbr': 'AE' },
  { 'cnName': '英国', 'enName': 'United Kingdom', 'enAbbr': 'GB' },
  { 'cnName': '美国', 'enName': 'United States', 'enAbbr': 'US' },
  { 'cnName': '乌拉圭', 'enName': 'Uruguay', 'enAbbr': 'UY' },
  { 'cnName': '乌兹别克斯坦', 'enName': 'Uzbekistan', 'enAbbr': 'UZ' },
  { 'cnName': '瓦努阿图', 'enName': 'Vanuatu', 'enAbbr': 'VU' },
  { 'cnName': '梵蒂冈', 'enName': 'Vatican City', 'enAbbr': 'VA' },
  { 'cnName': '委内瑞拉', 'enName': 'Venezuela', 'enAbbr': 'VE' },
  { 'cnName': '越南', 'enName': 'Vietnam', 'enAbbr': 'VN' },
  { 'cnName': '瓦利斯和富图纳', 'enName': 'Wallis & Futuna', 'enAbbr': 'WF' },
  { 'cnName': '也门', 'enName': 'Yemen', 'enAbbr': 'YE' },
  { 'cnName': '赞比亚', 'enName': 'Zambia', 'enAbbr': 'ZM' },
  { 'cnName': '津巴布韦', 'enName': 'Zimbabwe', 'enAbbr': 'ZW' }
]
